import { CUSTOMER_JOURNEY_EVENTS_CATEGORY } from './../const';

function action(catId, token, lang, context) {
  return { type: CUSTOMER_JOURNEY_EVENTS_CATEGORY, catId, token, lang, context };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyEventsCategory.js